module.exports = __webpack_public_path__ + "static/graphql-ddd771640806f25f7ad7a98ab20a611a.png";